import React from 'react';
import { routes } from 'constants/config';
import { componentClass } from './index';

const V2Banner = ({ isOldPage }) => {
  return (
    <div className={componentClass('banner')}>
      {isOldPage ? (
        <>
          {t('insights.v2.banner.back_description')}{' '}
          <a href={routes.INSIGHTS.V2}>{t('insights.v2.banner.back_link')}</a>
        </>
      ) : (
        <>
          {t('insights.v2.banner.description')}{' '}
          <a href={routes.INSIGHTS.INDEX}>{t('insights.v2.banner.link')}</a>
        </>
      )}
    </div>
  );
};

export default V2Banner;
